import uuidMixin from './mixin_uuid'

export default {
  mixins: [uuidMixin],
  props: {
    required: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.handleChangeEvent = false
  },
  computed: {
    dirty: {
      get: function () {
        return !this.pristine
      },
      set: function (newValue) {
        this.pristine = !newValue
      }
    },
    invalid () {
      return !this.valid
    }
  },
  methods: {
    setTouched () {
      this.touched = true
    },
    resetScrollTop(){
      var ua = window.navigator.userAgent;
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0) { //键盘收起页面空白问题
        document.body.scrollTop = this.scrollTop;
        document.documentElement.scrollTop = this.scrollTop;
      }
    },
    /* 获取窗口滚动条高度 */
    getScrollTop(){  
      var scrollTop=0;  
      if(document.documentElement&&document.documentElement.scrollTop){  
          scrollTop=document.documentElement.scrollTop;  
      }else if(document.body){  
          scrollTop=document.body.scrollTop;  
      }  
      return scrollTop;  
    }
  },
  watch: {
    value (newVal) {
      if (this.pristine === true) {
        this.pristine = false
      }
      if (!this.handleChangeEvent) {
        this.$emit('on-change', newVal)
        this.$emit('input', newVal)
      }
    }
  },
  data () {
    return {
      errors: {},
      pristine: true,
      touched: false,
      scrollTop:0
    }
  }
}

